export default function usePageCountReducer() {
  return (pageCount) => {
    return pageCount == null ? 0 : pageCount + 1;
  };
}
